import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import { AppBar, Toolbar, Link } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { SimpleBackdrop, SuccessButton } from "..";
import clsx from "clsx";
import RefreshIcon from "@material-ui/icons/Refresh";
import { useModalManager } from "../../hooks/useModalManager";
import { DOC_MODAL } from "../../helpers/DocumentModalLayout";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "-webkit-sticky",
    position: "sticky",
    backgroundColor: "white",
    flexShrink: 0,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  root: {
    borderRadius: "16px",
    marginRight: "20px",
  },
  // Адаптивный футер: на мобилках потоковый (static), на ПК (lg и выше) — закрепленный снизу
  footerContainer: {
    backgroundColor: "white",
    paddingTop: "12px",
    marginTop: "auto",
    flexShrink: 0,
    [theme.breakpoints.up("lg")]: {
      position: "sticky",
      top: "auto",
      bottom: 0,
      zIndex: 100,
    },
    [theme.breakpoints.down("md")]: {
      position: "relative", // на мобилках идет в потоке документа
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide in={props.in} direction="down" ref={ref} {...props} />;
});

const DocumentModal = (props) => {
  const {
    modalShow,
    modalTitle,
    onClose,
    onSubmit,
    loading,
    isAddMode,
    docOrganization,
    update,
    setUpdate,
    footer,
  } = props;
  useModalManager(modalShow, onClose);
  const dispatch = useDispatch();
  const classes = useStyles();

  const { organization } = useSelector((state) => state.users.usersList);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="simple-dialog"
      open={modalShow}
      fullScreen={true}
      TransitionComponent={Transition}
      TransitionProps={{ in: modalShow }}
      scroll="paper"
      PaperProps={{ className: DOC_MODAL.dialogPaper }}
    >
      <AppBar className={classes.appBar}>
        <Toolbar className="justify-between">
          <Typography
            variant="h6"
            color="textPrimary"
            className={classes.title}
            style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {modalTitle +
              " от организации " +
              (organization?.nameOrganization || "Не указана")}
            {!isAddMode && docOrganization}
          </Typography>

          <IconButton
            title="Обновить данные"
            className={classes.root}
            onClick={setUpdate}
            size="small"
          >
            <RefreshIcon color="primary" />
          </IconButton>

          <IconButton
            edge="start"
            color="default"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <MuiDialogContent
        className={`mt-3 ${DOC_MODAL.dialogContent}`}
        style={{ position: "relative", paddingBottom: 0 }}
      >
        {props.children}
        
        {/* Футер рендерится внутри контента модалки — на мобилках он будет в самом низу прокрутки */}
        {footer && (
          <AppBar component="div" elevation={0} className={classes.footerContainer}>
            {footer}
          </AppBar>
        )}

        {loading && <SimpleBackdrop show={loading} />}
      </MuiDialogContent>
    </Dialog>
  );
};

export default DocumentModal;